<template>
  <div class="container">
    <div class="search" style="display:flex">
      <el-form ref="form" style="flex:1" :inline="true" :model="search" class="demo-form-inline">
        <!-- <el-form-item>
          <el-select v-model="form.region" @change="selectchange" placeholder="请选择区域">
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-input v-model="search.kname" @change="Search" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="search.route" @change="Search" placeholder="路径"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select clearable v-model="search.menu_id" placeholder="所属菜单" @change="Search">
            <el-option v-for="item in menulist" v-bind:key="item.id" v-bind:label="item.name" v-bind:value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" size="small" @click="addfun">添加功能</el-button>
      </div>
    </div>
    <!-- 列表 -->
    <el-table border v-bind:data="list">
      <!-- <el-table-column label="序号" type="index" width="50"></el-table-column> -->
      <el-table-column label="功能名称">
        <template v-slot="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="所属菜单">
        <template v-slot="scope">
          <span>{{ menuNameId[scope.row.menu_id] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="uri路径">
        <template v-slot="scope">
          <span>{{ scope.row.route }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <el-button type="primary" size="small" @click="editfun(scope.row)">修改</el-button>
          <el-button type="danger" size="small" @click="deletfun(scope.row.id)">删除</el-button>
          <!-- <el-button type="info" size="small" @click="powerdistribut(scope.row.id)">权限分配</el-button> -->
          <i style="font-weight: 700" class="el-icon-top sort" @click="funcSort(scope.row,2)"></i>
          <i style="font-weight: 700" class="el-icon-bottom sort" @click="funcSort(scope.row,1)"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      v-model:currentPage="search.page"
      :page-size="search.limit"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>

    <!-- 新增修改 -->
    <el-dialog :title="title+'功能'" v-model="dialogFormVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="所属菜单" prop="menu_id" label-width="100px">
            <el-select v-model="form.menu_id" placeholder="">
              <el-option v-for="item in menulist" v-bind:key="item.id" v-bind:label="item.name" v-bind:value="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="功能名称" prop="name" label-width="100px">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="uri路径" prop="route" label-width="100px">
          <el-input v-model="form.route" autocomplete="off"></el-input>
        </el-form-item>
        <!-- <el-form-item label="分配角色" label-width="100px">
          <el-checkbox-group v-model="checkList">
            <el-checkbox @change="checked($event,item)" v-for="item in Rolelist" :value="item.role_id" :key="item.role_id" :label="item.name"></el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" v-if="!edit" @click="Validate(addconfirm)">新增</el-button>
          <el-button type="primary" v-if="edit" @click="Validate(editconfirm)">修改</el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="权限分配" v-model="powerShow" width="600px">
      <el-form>
        <el-form-item label="分配角色" label-width="100px">
          <el-checkbox-group v-model="checkList">
            <el-checkbox @change="checked($event,item)" v-for="item in Rolelist" :value="item.role_id" :key="item.role_id" :label="item.name"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="powerShow = false">完成</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: '',
  mixins: [],
  components: {},
  props: {},
  data () {
    return {
      search: {
        page: 1,
        limit: 10,
        kname: '',
        menu_id: '',
        route: ''
      },
      list: [],
      total: 0,
      dialogFormVisible: false,
      title: '',
      form: {
        id: '',
        name: '',
        menu_id: '',
        route: '',
      },
      rules: {
        name: [{ required: true, message: '请输入功能名称', trigger: 'blur' }],
        menu_id: [{ required: true, message: '请输入所属菜单id', trigger: 'blur' }],
        route: [{ required: true, message: '请输入uri路径', trigger: 'blur' }],
      },
      edit: false,
      checkList: ['选中且禁用','复选框 A'],
      menulist: [],
      menuNameId: {},
      Rolelist: [],
      powerShow: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    GetroleList () {
      this.roleNameId = {}
      this.api.RoleList({
        page: 1,
        limit: 100,
      }).then(res => {
        if (res.data.code == 200) {
          this.Rolelist = res.data.data.data
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    powerdistribut(item) {
      this.GetroleList()
      this.powerShow = true
    },
    checked (event,check){
      
    },
    GetMenu () {
      this.api.MenuList({
        page: 1,
        limit: 100,
      }).then(res => {
        if (res.data.code == 200) {
          this.menulist = res.data.data.data
          res.data.data.data.forEach(item => {
            this.menuNameId[item.id] = item.name
          });
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.Search()
    },
    Search () {
      this.api.FuncList({
        page: this.search.page,
        limit: this.search.limit,
        kname: this.search.kname,
        menu_id: this.search.menu_id,
        route: this.search.route
      }).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data.data
          this.total = res.data.data.page_info.total
          return
        }
        this.$message.error('获取失败' + res.data.msg)
      })
    },
    addfun () {
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.form = {}
      this.edit = false
      this.title = '新增'
      this.dialogFormVisible = true
      this.form.menu_id = this.search.menu_id==0?'':this.search.menu_id
    },
    editfun(item) {
      this.form = {}
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
      this.edit = true
      this.title = '修改'
      this.dialogFormVisible = true
      this.api.FuncDetail({id:item.id}).then(res => {
        if (res.data.code == 200) {
          this.form=res.data.data
          return
        }
        this.$message.error('获取详情失败' + res.data.msg)
      })
    },
    deletfun(item) {
      this.$confirm('是否删除该功能?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 删除请求
        this.api.FuncDelete({id: item}).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            this.Search()
            return
          }
          this.$message.error('删除失败' + res.data.msg)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除'
        });
      })
    },
    funcSort (item,direction) {
      this.api.FuncSort({
        action: direction,
        id: item.id
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success('修改排序成功')
          this.Search()
          return
        }
        this.$message.error('修改排序失败' + res.data.msg)
      })
    },
    Validate: function (call) {
      this.$refs['form'].validate(res => {
        if (res && call) {
          call()
        }
      })
    },
    update() {
      this.api.FuncUpdate({
        id: this.form.id,
        name: this.form.name,
        menu_id: +this.form.menu_id,
        route: this.form.route,
      }).then(res => {
        if (res.data.code == 200) {
          this.$message.success(this.title +'成功')
          this.dialogFormVisible = false
          this.Search()
          return
        }
        this.$message.error(this.title +'失败' + res.data.msg)
      })
    },
    addconfirm () {
      this.update()
    },
    editconfirm () {
      this.update()
    },
    selectchange() {
      
    }
  },
  filters: {},
  mounted () {
    this.Search()
  },
  created () {
    this.GetMenu()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.sort {
  font-size: 16px;
  margin: 0 5px;
  cursor: pointer;
  font-weight: 700px!important;
}
</style>
